import {useWbAgentClient} from '@wandb/weave/lib/WbAgent/useWbAgentClient';
import {useCallback} from 'react';

import {deleteThread} from '../../../agentChat/mutations/deleteThread';
import {
  useAgentChatDispatch,
  useAgentChatStore,
} from '../../../agentChat/store/context';
import {useNavContext} from '../../NavContextProvider';

/** useDeleteThread returns a function that optimistically deletes a thread. */
export function useDeleteThread() {
  const {params} = useNavContext();
  const client = useWbAgentClient(params.entityName, params.projectName);
  const dispatch = useAgentChatDispatch();
  // oxlint-disable-next-line wandb/zustand-use-store-selectors - not a zustand store.
  const store = useAgentChatStore();

  return useCallback(
    (threadId: string): Promise<void> => {
      if (!client) {
        return Promise.resolve();
      }

      return deleteThread({client, dispatch, store, threadId});
    },
    [client, dispatch, store]
  );
}
